import React from "react";
import { Route } from "react-router-dom";
import SalesInvoiceReport from "../../../containers/modules/report/sales-report";
import AccessControl from "../../../components/utilities/Class/AccessControl";

export default function SalesReportRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="sales-report"
      index
      element={
        <AccessControl
          name={"Sales Invoice Report Show"}
          auth={authUser}
          component={() => <SalesInvoiceReport />}
        />
      }
    ></Route>
  );
}
